<template>
  <div class="content">
		Error Content
  </div>
</template>
